<div class="logo-container">
  @if (logoUrl) {
    <img class="logo" [src]="logoUrl">
  } @else {
    <img class="logo" src="/logo.cenplex-booking.png">
  }
</div>
